'use client'

import * as React from 'react'

import type { Direction } from '../styles/theme/types'

interface Props {
  children: React.ReactNode
  direction?: Direction
}

const Rtl = ({ children, direction = 'ltr' }: Props) => {
  React.useEffect(() => {
    document.dir = direction
  }, [direction])

  return <React.Fragment>{children}</React.Fragment>
}

export default Rtl
